function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#ef3444;}"));

var _ref3 = /*#__PURE__*/React.createElement("title", null, "The Red Robin Creative Logo");

var _ref4 = /*#__PURE__*/React.createElement("g", {
  "data-name": "Layer 2"
}, /*#__PURE__*/React.createElement("g", {
  id: "base"
}, /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1301,701V0h350c193,0,350,158,350,351s-157,350-350,350Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M4.31,483.39a6,6,0,0,1,2.13.64l11.21,5.77,16.57,4.13L35.36,491l-21.6-54.08L0,435v49.59A6.1,6.1,0,0,1,4.31,483.39Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M88.55,548.89l-1-2.34a6.21,6.21,0,0,1-1.61,0l-.37-.05,2.92,7.92Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M621,285C621,127,493,0,336,0H0V166.42a7.09,7.09,0,0,1,1-.7L51.56,137a7.47,7.47,0,0,1,2.79-.92l43.52-5.25a7.18,7.18,0,0,1,1.67,0,8.36,8.36,0,0,1,1.23.24l40.8,11.45a7.39,7.39,0,0,1,3.84,2.57L169.67,176l27.25,2.87a7.48,7.48,0,0,1,2.41.68l7.88,3.74a7.51,7.51,0,0,1,3.61,3.68l.84,1.89a7.44,7.44,0,0,1-7.57,10.42,5.37,5.37,0,0,1-.7-.11h0l-9.6,4a7.42,7.42,0,0,1-1.61.46l-22.8,3.8-12.9,39.77,5.17,41.22a7.33,7.33,0,0,1-.16,2.72l-18.68,75.13a7.45,7.45,0,0,1-2.29,3.78L75.25,427.61a7.42,7.42,0,0,1-3.71,1.77l-40.27,6.68L55,485.55,58.59,491a6,6,0,0,1,.44.78L63.39,501,75,507.34a6,6,0,0,1,1.8,1.48l12,14.62L102.64,537a6.07,6.07,0,0,1,1.72,5.48l-3.78,19.63a6,6,0,0,1-9.48,3.77l-.09-.06a6,6,0,0,1-2.51-4.73l-.89,8.41a6,6,0,0,1-1.15,3L77.93,584a6.07,6.07,0,0,1-8.41,1.32l-.27-.2a6,6,0,0,1-2.36-6.29l1.94-8.3a6,6,0,0,1-4.54-5L59.9,534.3l-2.72-5.36-6.92,6.94a6.07,6.07,0,0,1-9-.47l-.25-.32a6.06,6.06,0,0,1-1.14-5.39l2.05-7.61-5.69-5.75-22.35-6.4A6.05,6.05,0,0,1,9.79,506l-1.35-4.1-2.67-1.75-5.77,2V701H615L512,508C579,456,621,376,621,285Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1161,233.67H1044.77V409.22H927.33v58.11H1286L1161,701H635.55V0H1286Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M81.28,869.69l-21.57-37H37v37H.37V730.19H59.15A51.2,51.2,0,0,1,93.93,819.1l29.58,50.59ZM37,801.06H59.71a20,20,0,1,0,0-40H37Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M204.6,730.19A69.75,69.75,0,1,1,135,800.13C135,761.63,166.1,730.19,204.6,730.19Zm0,36.46a33.3,33.3,0,1,0,33.3,33.29A33.22,33.22,0,0,0,204.6,766.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M299.83,869.69V730.19H361.4c22.32,0,41.29,19.16,41.29,41.48a40.81,40.81,0,0,1-8.93,25.11c9.49,7.63,15.81,19.34,15.81,32,0,22.14-18.78,40.92-40.92,40.92Zm54.31-85a12.09,12.09,0,0,0,0-24.18H336.47v24.18ZM361,839.56a12.07,12.07,0,0,0,12.09-12.09A12.31,12.31,0,0,0,361,815.38H336.47v24.18Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M431.33,730.19H468v139.5H431.33Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M598.54,869.69l-65.84-66v66H496.06V730.19h14.88L577,796V730.19h36.64v139.5Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M815.23,776.32c-5.77-5.77-14-9.11-23.44-9.11-19,0-32.73,13.76-32.73,32.73s13.76,32.74,32.73,32.74c9.49,0,17.67-3.35,23.44-9.3l26,25.67a69.74,69.74,0,1,1-49.48-118.86,69.05,69.05,0,0,1,49.11,20.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M950.08,869.69l-21.58-37H905.81v37H869.17V730.19H928a51.21,51.21,0,0,1,34.78,88.91l29.57,50.59Zm-44.27-68.63H928.5a20,20,0,1,0,0-40H905.81Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1010.34,730.19H1097v30.32h-50V783.2h44.27v30.88H1047v25.67h50v29.94h-86.68Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1113.94,869.69l65.1-139.5h16.56l65.66,139.5h-36.65l-8.55-18.23H1159l-8.37,18.23Zm59.34-49.1h28.45L1187.6,789.9Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1267.58,730h109.93v36.46h-37V869.69h-36.64V766.46h-36.27Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1402.61,730.19h36.65v139.5h-36.65Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1601.82,730l-64.91,139.69h-16.74L1455.06,730h36.83l36.65,79.43L1565.36,730Z"
}), /*#__PURE__*/React.createElement("path", {
  className: "cls-1",
  d: "M1617.81,730.19h86.68v30.32h-50V783.2h44.26v30.88h-44.26v25.67h50v29.94h-86.68Z"
})));

var SvgRedRobinCreativeLogo = function SvgRedRobinCreativeLogo(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 2001 869.69",
    ref: svgRef
  }, props), _ref2, title === undefined ? _ref3 : title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref4);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRedRobinCreativeLogo, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/red-robin-creative-logo.1fb15c1b.svg";
export { ForwardRef as ReactComponent };